import axios from "axios";
import { BACKEND_BASE_URL, DEL_CUST_BILL, DEL_ENTIRE_BILL, DEL_ROOM_BILL, FAILED, GET_BILL_DETAILS, GET_CATEOGORY_DATA, GET_CUST_BY_MOB, HotelRoomCateogory, isEmpty, NODATA, printDebugLog, SUCCESS, TEST_BACKEND_BASE_URL } from "../../constants/Constants";
import { INITIAL_SNP_COMPONENT } from "../../constants/pojoservice";
import { isValidTenDigitNumber } from "../../constants/commonUtils";

export const handleOnClickRoom = async (
    {
        authUser, activeShopHash, id,
        setSnpLoader, setSameDayBookingCount, setBookings
    }
) => {
    if (!authUser) {
        return;
    }
    setSnpLoader && setSnpLoader(true);
    try {
        const catgUrl = `${BACKEND_BASE_URL}fetch-calendar-view-by-room`;
        const mData = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                roomId: id
            },
        };
        const response = await axios.post(catgUrl, mData);
        printDebugLog("handleOnClickRoom", response.data);
        if (response.data.status === SUCCESS) {
            const payLoad = response.data.payLoad;
            const roomBooked = payLoad.roomBooked || false;
            if (roomBooked) {
                setSameDayBookingCount(payLoad.sameDateBookingCount);
                setBookings(payLoad.details || []);
            } else {
                setSameDayBookingCount({});
                setBookings([]);
            }
        }
        setSnpLoader && setSnpLoader(false);
    } catch (error) {
        console.error("handleOnClickRoom Error : ", error);
        setSnpLoader && setSnpLoader(false);
    }
}

export const fetchBanquetForBill = async ({
    authUser, activeShopHash, start, end,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${BACKEND_BASE_URL}fetch-banquet-for-bill`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                start: start,
                end: end,
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("fetchBanquetForBill", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
    } catch (error) {
        console.error("fetchBanquetForBill : ", error);
        onResponseCallback(null, true);
    }
};

export const fetchFewRoomDetails = async ({
    authUser, activeShopHash, checkOutDate,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${BACKEND_BASE_URL}fetch-available-room`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                checkOutDate: checkOutDate,
                type: HotelRoomCateogory.HOTEL_ROOM,
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("fetchFewRoomDetails", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad);
        }
    } catch (error) {
        console.error("fetchFewRoomDetails : ", error);
    }
};


export const getBanquetInformation = async ({
    authUser, activeShopHash, mRoomId,
    setSnpLoader, onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        setSnpLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}fetch-room-banquet-information`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                roomId: mRoomId,
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("getBanquetInformation", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad);
        }
        setSnpLoader(false);
    } catch (error) {
        console.error("getBanquetInformation : ", error);
        setSnpLoader(false);
    }
};


export const getBillData = async ({
    authUser, activeShopHash, myParam,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    if (myParam) {
        try {

            const catgUrl = `${BACKEND_BASE_URL}fetch-bill-information`;
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    billId: myParam,
                },
            };
            const response = await axios.post(catgUrl, data);
            printDebugLog("getBillData", response.data);
            if (response.data.status === SUCCESS) {
                onResponseCallback(response.data.payLoad, false);
            } else {
                onResponseCallback(null, true);
            }
        } catch (error) {
            onResponseCallback(null, true);
            console.error("getBillData Error : ", error);
        }
    } else {
        console.log("getBillData : myParam is empty");
    }
};

export const fetchBanquetBillPayInformation = async ({
    authUser, activeShopHash, mBillid, setSnpLoader,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        setSnpLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}fetch-banquet-bill-pay-information`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                billId: mBillid
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("fetchBanquetBillPayInformation", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad);
        }
        setSnpLoader(false);
    } catch (error) {
        console.error("fetchBanquetBillPayInformation : ", error);
        setSnpLoader(false);
    }
};

export const fetchBanquetBillPayAuditInformation = async ({
    authUser, activeShopHash, mBillid,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        const catgUrl = `${BACKEND_BASE_URL}fetch-banquet-bill-pay-audit-information`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                billId: mBillid,
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("fetchBanquetBillPayAuditInformation", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad);
        }
    } catch (error) {
        console.error("fetchBanquetBillPayAuditInformation : ", error);
    }
};
export const fetchComboFoodDetails = async ({
    authUser, activeShopHash, setSnpLoader,
    onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    try {
        setSnpLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}fetch-combo-food-details`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
            },
        };
        const response = await axios.post(catgUrl, data);
        printDebugLog("fetchComboFoodDetails", response.data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
        setSnpLoader(false);
    } catch (error) {
        setSnpLoader(false);
        console.error("fetchComboFoodDetails : ", error);
        onResponseCallback(null, true);
    }
};



export const fetchSingleCustomerData = async ({ authUser, activeShopHash, myParam,
    setSnpLoader, onResponseCallback, onLocalMsg }) => {
    if (!authUser) {
        return;
    }
    if (myParam && myParam.length === 10) {
        if (!isValidTenDigitNumber(myParam)) {
            onLocalMsg('Please enter a valid 10-digit number without space/letter.')
            return;
        }
        try {
            setSnpLoader(true);
            const catgUrl = `${BACKEND_BASE_URL}${GET_CUST_BY_MOB}`;
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    mobNo: myParam,
                },
            };
            //console.log("fetchSingleCustomerData => ",data);
            const response = await axios.post(catgUrl, data);
            if (response.data.status === SUCCESS) {
                onResponseCallback(response.data.payLoad, false);
            } else {
                onResponseCallback(null, true);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("fetchSingleCustomerData Error : ", error);
            setSnpLoader(false);
            onResponseCallback(null, true);
        }
    }
};


export const deleteCustomerFromBill = async ({ custData, billId,
    setSnpLoader, onResponseCallback }) => {
    try {
        let no = "";
        let dets = "";
        if (!isEmpty(custData.mobNo)) {
            no = "1";
            dets = custData.mobNo;
        } else {
            if (!isEmpty(custData.aadharId)) {
                no = "2";
                dets = custData.aadharId;
            } else if (!isEmpty(custData.custName)) {
                no = "3";
                dets = custData.custName;
            }
        }
        setSnpLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}${DEL_CUST_BILL}/${billId}/${no}/${dets}`;
        //console.log("fetchSingleCustomerData => ",data);
        const response = await axios.get(catgUrl);
        onResponseCallback(response.data);
        setSnpLoader(false);
    } catch (error) {
        console.error("fetchSingleCustomerData Error : ", error);
        setSnpLoader(false);
        onResponseCallback(FAILED);
    }
};

export const handleSubmitBill = async ({ authUser, activeShopHash,
    billingModel,
    setSnpLoader, onResponseCallback }) => {

    if (!authUser) return;

    try {
        setSnpLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}persist-banquet-bill`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                ...billingModel,
            },
        };
        const response = await axios.post(catgUrl, data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
        setSnpLoader(false);
    } catch (error) {
        console.error("handleSubmitBill Error : ", error);
        setSnpLoader(false);
        onResponseCallback(null, true);
    }
};

export const handleDeleteEntireBill = async ({ id, activeShopHash, setSnpLoader, setSnpComponent, navigate }) => {
    if (isEmpty(id))
        setSnpComponent(prev => ({
            ...prev,
            snackBarMsg: "Still Bill not created",
            snackBarOpen: true,
        }));
    else {
        try {
            const deleteUrl = `${BACKEND_BASE_URL}${DEL_ENTIRE_BILL}/${activeShopHash.id}/${id}`;
            const response = await axios.get(deleteUrl);
            if (response.data === SUCCESS) {
                setSnpComponent(prev => ({
                    ...prev,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Home",
                    positiveAction: "",
                    positiveReq: false,
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    subTitle: "Bill Deleted Successfully",
                    handleSnpCancel: () => navigate("/home"),
                }));
            } else {
                console.warn("handleDeleteEntireBill resp: ", response.data);
            }
        } catch (error) {
            console.error("handleDeleteEntireBill Error : ", error);
            setSnpLoader(false);
        }
    }
};


export const handleDeleteUnpaidDetails = async ({ id,
    authUser, activeShopHash, setSnpLoader, setSnpComponent, navigate }) => {
    if (isEmpty(id))
        setSnpComponent(prev => ({
            ...prev,
            snackBarMsg: "Still Bill not created",
            snackBarOpen: true,
        }));
    else {
        try {
            const deleteUrl = `${BACKEND_BASE_URL}delete-partialbill-audit?apiToken=${authUser.apiToken}&shopHash=${activeShopHash.id}&id=${id}`;
            const response = await axios.get(deleteUrl);
            if (response.data.status === SUCCESS) {
                setSnpComponent(prev => ({
                    ...prev,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Home",
                    positiveAction: "Dismiss",
                    positiveReq: true,
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    subTitle: "Deleted Successfully",
                    handleSnpCancel: () => navigate("/home"),
                    handleSubmitBill: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                }));
            } else {
                console.warn("handleDeleteUnpaidDetails resp: ", response.data);
            }
        } catch (error) {
            console.error("handleDeleteUnpaidDetails Error : ", error);
            setSnpLoader(false);
        }
    }
};

export const showAvailableRooms = async ({ authUser, activeShopHash, checkInDate, checkOutDate, mDate = true, advanceBooking = false,
    setLoader, onResponseCallback }) => {
    if (!authUser)
        return;
    try {
        setLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}fetch-available-room`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                checkInDate: checkInDate,
                checkOutDate: checkOutDate,
                date: mDate,
                advanceBooking: advanceBooking,
            },
        };
        //console.log("fetchSingleCustomerData => ",data);
        const response = await axios.post(catgUrl, data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(response.payLoad.payLoad, true);
        }
        setLoader(false);
    } catch (error) {
        console.error("showAvailableRooms Error : ", error);
        setLoader(false);
        onResponseCallback(null, true);
    }
};

export const showSingleRoom = async ({ authUser, activeShopHash, roomId,
    setLoader, onResponseCallback }) => {
    if (!authUser)
        return;
    try {
        setLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}fetch-single-room`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                roomId: roomId,
            },
        };
        //console.log("fetchSingleCustomerData => ",data);
        const response = await axios.post(catgUrl, data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(response.payLoad.payLoad, true);
        }
        setLoader(false);
    } catch (error) {
        console.error("showSingleRoom Error : ", error);
        setLoader(false);
        onResponseCallback(null, true);
    }
};

export const getMainCateogoryData = async ({
    authUser, activeShopHash, onResponseCallback
}) => {
    if (!authUser) {
        return;
    }
    const catgUrl = `${BACKEND_BASE_URL}${GET_CATEOGORY_DATA}`;
    const data = {
        payLoad: {
            apiToken: authUser.apiToken,
            shopHash: activeShopHash.id,
            type: HotelRoomCateogory.HOTEL_ROOM,
            isAll: true,
        },
    };

    try {
        const response = await axios.post(catgUrl, data);
        const fullData = response.data.payLoad?.data;
        if (Array.isArray(fullData) && fullData.length > 0) {
            onResponseCallback(fullData, false);
        } else {
            onResponseCallback(null, true);
        }
    } catch (error) {
        console.error("getMainCateogoryData Error : ", error);
        onResponseCallback(null, true);
    }
};

export const getMainRoomData = async ({
    authUser, activeShopHash, selectedCategory, onResponseCallback, setSnpLoader, type, selectedDate
}) => {
    if (!authUser) return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}fetch-room-banquet-info`;
    const data = {
        payLoad: {
            apiToken: authUser.apiToken,
            shopHash: activeShopHash.id,
            catgId: selectedCategory ? selectedCategory.id : "",
            type: type,
            selectedDate: selectedDate,
        },
    };

    try {
        const response = await axios.post(catgUrl, data);

        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
    } catch (error) {
        console.error("getMainRoomData Error : ", error);
        onResponseCallback(null, true);
    } finally {
        setSnpLoader(false);
    }
};


export const fetchMainBillFromRoom = async ({
    authUser, activeShopHash, mRoom, onResponseCallback, setSnpLoader,
}) => {
    if (!authUser) return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}fetch-bill-from-room?shopHash=${activeShopHash.id}&roomId=${mRoom.id}&apiToken=${authUser.apiToken}`;

    try {
        const response = await axios.get(catgUrl);
        const newBookingNotAllowed = response?.data?.payLoad.newBookingNotAllowed ?? false;
        if (response.data.status === SUCCESS) {
            const fullData = response.data.payLoad?.fullData;
            if (Array.isArray(fullData) && fullData.length > 0) {
                onResponseCallback(fullData, newBookingNotAllowed, false);
            } else {
                onResponseCallback(null, newBookingNotAllowed, true);
            }
        } else {
            onResponseCallback(null, newBookingNotAllowed, true);
        }
    } catch (error) {
        console.error("fetchMainBillFromRoom Error : ", error);
        onResponseCallback(null, false, true);
    } finally {
        setSnpLoader(false);
    }
};

export const getBaseBillData = async ({
    authUser, activeShopHash, myParam, onResponseCallback, setSnpLoader, viaBill,
}) => {
    if (!authUser) return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}${GET_BILL_DETAILS}`;
    const data = {
        payLoad: {
            apiToken: authUser.apiToken,
            shopHash: activeShopHash.id,
            roomId: myParam,
            viaBill: viaBill,
        },
    };

    try {
        const response = await axios.post(catgUrl, data);

        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
    } catch (error) {
        console.error("getBaseBillData Error : ", error);
        onResponseCallback(null, true);
    } finally {
        setSnpLoader(false);
    }
};

export const checkExistingRoomAvailability = async ({ authUser, activeShopHash, billId,
    checkInDateChange, changedDate, date,
    setLoader, onResponseCallback }) => {
    if (!authUser)
        return;
    try {
        setLoader(true);
        const catgUrl = `${BACKEND_BASE_URL}check-existing-room`;
        const data = {
            payLoad: {
                apiToken: authUser.apiToken,
                shopHash: activeShopHash.id,
                billId: billId,
                checkInDateChange: checkInDateChange,
                changedDate: changedDate,
                date: date,
            },
        };
        //console.log("fetchSingleCustomerData => ",data);
        const response = await axios.post(catgUrl, data);
        if (response.data.status === SUCCESS) {
            onResponseCallback(response.data.payLoad, false);
        } else {
            onResponseCallback(null, true);
        }
        setLoader(false);
    } catch (error) {
        console.error("showAvailableRooms Error : ", error);
        setLoader(false);
        onResponseCallback(null, true);
    }
};


export const deleteRoomFromBill = async ({
    authUser, activeShopHash, mRoom, mBillId, onResponseCallback, setSnpLoader,
}) => {
    if (!authUser) return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}${DEL_ROOM_BILL}/${activeShopHash.id}/${mBillId}/${mRoom}`;

    try {
        const response = await axios.get(catgUrl);
        onResponseCallback(response.data);
    } catch (error) {
        console.error("deleteRoomFromBill Error : ", error);
        onResponseCallback(NODATA);
    } finally {
        setSnpLoader(false);
    }
};